
import Swiper from 'swiper';
import { Mousewheel, FreeMode } from 'swiper/modules';

import 'swiper/swiper-bundle.css';

document.querySelectorAll('[data-home-hightlights]').forEach(slider => {

    const options = {
      modules: [Mousewheel, FreeMode],
      direction: 'horizontal',
      slidesPerView: 'auto',
      loop: false,
      autoHeight: false,
      allowTouchMove: true,
      spaceBetween: 8,
      centeredSlides: false,
      mousewheel: {
        forceToAxis: true,
        releaseOnEdges: true, // lets page scroll take over at the end
        sensitivity: 1,
      },
      freeMode: {
        enabled: true,
        momentum: true,
        momentumBounce: true,
      },
      breakpoints: {
        600: {
          spaceBetween: 8,
        },
        1024: {
          spaceBetween: 40,
        }
      }
    }

    const swiper = new Swiper(slider.querySelector('.swiper'), options);
  }
)

